import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserProfile = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "User_profile",
	"data-name": "User profile",
	xmlns: "http://www.w3.org/2000/svg",
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Rectangle_13",
		"data-name": "Rectangle 13",
		fill: "none",
		stroke: "#fff",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 34,
			height: 34,
			rx: 17,
			stroke: "none"
		}), /* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 1,
			width: 32,
			height: 32,
			rx: 16,
			fill: "none"
		})]
	}), /* @__PURE__ */ _jsxs("g", {
		id: "Icon_akar-person",
		"data-name": "Icon akar-person",
		transform: "translate(4.102 4.143)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Path_3667",
			"data-name": "Path 3667",
			d: "M19.317,7.409A4.409,4.409,0,1,1,14.909,3a4.409,4.409,0,0,1,4.409,4.409Z",
			transform: "translate(-2.309)",
			fill: "none",
			stroke: "#fff",
			strokeWidth: 1.5
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_3668",
			"data-name": "Path 3668",
			d: "M17.008,21h.31a2.645,2.645,0,0,1,2.624,2.317l.345,2.754a1.763,1.763,0,0,1-1.75,1.982H6.662a1.763,1.763,0,0,1-1.75-1.982l.344-2.754A2.645,2.645,0,0,1,7.882,21h.309",
			transform: "translate(0 -7.42)",
			fill: "none",
			stroke: "#fff",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})]
	})]
});
export default SvgUserProfile;
